// Tarif de repli, appliqué uniquement quand une boutique n'a pas de tarif
// négocié. Le tarif réel se fixe boutique par boutique depuis la fiche
// marchand — voir services/deliveryFees.js pour l'ordre de priorité.
export const DEFAULT_DELIVERY_FEE = 2000;
export const HORS_DAKAR_DELIVERY_FEE = 2000;

export const DELIVERY_STATUS_THEME = {
  pending: {
    label: 'En attente',
    bg: '#fff7ed',
    color: '#c2410c',
    border: '#fed7aa',
    bar: '#c2410c',
  },
  transit: {
    label: 'En transit',
    bg: '#eff6ff',
    color: '#1d4ed8',
    border: '#bfdbfe',
    bar: '#1d4ed8',
  },
  delivered: {
    label: 'Livré',
    bg: '#f0fdf4',
    color: '#15803d',
    border: '#bbf7d0',
    bar: '#15803d',
  },
  failed: {
    label: 'Retour',
    bg: '#fff1f2',
    color: '#be123c',
    border: '#fecdd3',
    bar: '#be123c',
  },
};

export const DELIVERY_STATUS_CYCLE = {
  pending: 'transit',
  transit: 'delivered',
  delivered: 'failed',
  failed: 'pending',
};

export const DELIVERY_STATUS_CYCLE_LABEL = {
  pending: 'Marquer en transit',
  transit: 'Marquer livré',
  delivered: 'Marquer retour',
  failed: 'Remettre en attente',
};

/**
 * Le statut à afficher sur une fiche — un seul.
 *
 * Une commande porte deux statuts : sa confirmation (à traiter, rappel,
 * annulée, confirmée) et sa livraison (en attente, en transit, livrée,
 * retour). Ils ne sont pas informatifs au même moment :
 *  - tant que la commande n'est pas confirmée, sa livraison vaut toujours
 *    « En attente » et n'apprend rien — c'est la confirmation qui compte ;
 *  - une fois confirmée, c'est la livraison qui dit où elle en est.
 * Afficher les deux donnait « En attente » + « Rappel », ou pire
 * « Retour » + « Annulé » sur une commande annulée avant tout départ.
 */
export function pickOrderStatus(order, deliveryTheme, confirmationTheme) {
  const conf = order?.confirmation_status;
  if (conf && conf !== 'confirmed' && confirmationTheme?.[conf]) {
    return confirmationTheme[conf];
  }
  return deliveryTheme[order?.status] || deliveryTheme.pending;
}

/**
 * Couleur de la bande de rebord d'une carte commande.
 * Le bleu de la charte partout ; le rouge brique seulement pour une commande
 * en difficulté — retournée ou annulée —, la seule bande qui apprenne quelque
 * chose d'un coup d'œil. Les valeurs vivent dans index.css (--card-bar*).
 */
export function orderBarColor(order) {
  const problem = order?.status === 'failed' || order?.confirmation_status === 'cancelled';
  return problem ? 'var(--card-bar-alert)' : 'var(--card-bar)';
}
